import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isNavMinimized: false,
  isMobile: window.innerWidth <= 768,
};

const LayoutSlice = createSlice({
  name: 'Layout',
  initialState,
  reducers: {
    toggleNavigationBar(state, action) {
      state.isNavMinimized = !state.isNavMinimized;
    },
    setIsMobile: (state, action) => {
      state.isMobile = action.payload;
    },
  },
});

export const { toggleNavigationBar, setIsMobile } = LayoutSlice.actions;

export default LayoutSlice.reducer;
